import { DateTime } from 'luxon'

export function luxonFormat(value, format = 'y-LL-dd HH:mm:ss ZZZ', utc = true) {
  if (!value) return ''
  const millis = Date.parse(value)
  if (!millis) {
    return value
  }
  let dateToFormat = DateTime.fromMillis(millis)
  if (utc) {
    dateToFormat = dateToFormat.toUTC()
  }
  return dateToFormat.toFormat(format)

}

export function luxonFromNow(value) {
  if (!value) return ''
  const millis = Date.parse(value)
  return DateTime.fromMillis(millis || value).toRelative({ round: true })

}
